<template>
<div class="chapter">
<div class="inner_page">
<h1>100 Desserts for $5 or Less</h1>
<div class="toc">
<p>
<b>Table of Contents</b>
</p>
<dl>
<dt>
<span class="chapter">
<a href="#/ch01">Introduction </a>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch02" title="Link target outside of Sample">Author’s Notes </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch03" title="Link target outside of Sample">Cakes </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch04" title="Link target outside of Sample">Candy </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch05" title="Link target outside of Sample">Cookies &amp; Bars </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch06" title="Link target outside of Sample">Desserts </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch07" title="Link target outside of Sample">Frozen Desserts </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch08" title="Link target outside of Sample">Pies &amp; Tarts </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch09" title="Link target outside of Sample">Sauces, Frostings, &amp; Dips </span>
</span>
</dt>
<dt>
<span class="chapter">
<span href="#/ch10" title="Link target outside of Sample">Metric Conversion Chart</span>
</span>
</dt>
</dl>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// bk01-toc.vue?18e923d6